import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import fontCalibri from "../../assets/fonts/calibri.ttf";
import fontCalibrib from "../../assets/fonts/calibrib.ttf";
import fontCalibrii from "../../assets/fonts/calibrii.ttf";

import { format } from "date-fns";

import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
  Link,
  Image
} from "@react-pdf/renderer";

import logo1 from "../pivot-rp-logo.png";
import logo2 from "../crowdhelix-logo.png";

Font.register({
  family: "Calibri",
  fonts: [
    {
      src: fontCalibri,
      fontStyle: "normal",
    },
    {
      src: fontCalibrib,
      fontWeight: "bold",
    },
    {
      src: fontCalibrii,
      fontStyle: "italic",
    },
  ],
});

// Helper function to parse HTML and extract text with styles
const parseHtmlForPdf = (htmlString) => {
  if (!htmlString || htmlString === "") return null;
  
  // Create a temporary DOM element to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  
  const extractTextWithStyle = (element) => {
    const elements = [];
    
    const traverse = (node, inheritedStyle = {}, isList = false) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        if (text && text.trim()) {
          elements.push({ text, style: { ...inheritedStyle }, isList });
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        let currentStyle = { ...inheritedStyle };
        let isListItem = isList;
        
        // Parse inline styles
        if (node.style) {
          if (node.style.color) {
            currentStyle.color = node.style.color;
          }
          if (node.style.fontWeight === "bold" || node.tagName === "B" || node.tagName === "STRONG") {
            currentStyle.fontWeight = "bold";
          }
          if (node.style.fontStyle === "italic" || node.tagName === "I" || node.tagName === "EM") {
            currentStyle.fontStyle = "italic";
          }
        }
        
        // Handle list items
        if (node.tagName === "LI") {
          isListItem = true;
        }
        
        // Traverse children
        node.childNodes.forEach(child => traverse(child, currentStyle, isListItem));
      }
    };
    
    traverse(element);
    return elements;
  };
  
  const textElements = extractTextWithStyle(tempDiv);
  
  if (textElements.length === 0) return null;
  
  return textElements.map((item, index) => (
    <Text key={index} style={item.style}>
      {item.isList ? "• " : ""}{item.text}
    </Text>
  ));
};

const styles = StyleSheet.create({
  page: {
    paddingTop: 35,
    paddingBottom: 45,
    paddingHorizontal: 35,
    fontFamily: "Calibri",
    fontSize: 10,
  },
  aktualniRazpisiNaslov: {
    color: "#006a8e",
    fontSize: 15,
    fontWeight: "bold",
    marginBottom: 5,
    paddingLeft: 3,
  },
  oddelekView: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    backgroundColor: "#ededed",
    padding: 5,
    paddingTop: 9,
  },
  oddelekNaslovView: {
    flexBasis: "80%",
    fontSize: 13,
    fontWeight: "bold",
  },
  oddelekVerzijaRazpisiView: {
    flexBasis: "20%",
    textAlign: "right",
  },
  opombaText: {
    padding: 5,
    textAlign: "justify",
  },
  izpostavljeniRazpisiView: {
    flexDirection: "row",
    alignItems: "center",
    color: "white",
    backgroundColor: "#2CB0AE",
    padding: 5,
    paddingTop: 10,
  },
  izpostavljeniRazpisiTitle: {
    fontSize: 13,
    fontWeight: "bold",
    flexBasis: "80%",
  },
  izpostavljeniRazpisiText: {
    flexBasis: "20%",
    textAlign: "right",
  },
  razpisiIzpotavljeniDynamicView: {
    flexDirection: "row",
    alignItems: "center",
    padding: 5,
    borderBottom: "1px solid silver",
  },
  razpisiIzpotavljeniDynamicViewLast: {
    flexDirection: "row",
    alignItems: "center",
    padding: 5,
  },
  razpisiIzpostavljeniNaziv: {
    flexBasis: "40%",
    paddingRight: 10,
  },
  razpisiIzpostavljeniOpis: {
    flexBasis: "45%",
    textAlign: "justify",
  },
  razpisiIzpostavljeniDatum: {
    flexBasis: "15%",
    textAlign: "right",
  },
  razpisiIzpostavljenDatumNovo: {
    border: "1px solid green",
    width: 25,
    color: "white",
    backgroundColor: "green",
    marginLeft: 53,
    marginBottom: 2,
    paddingTop: 5,
    paddingLeft: 2,
    paddingRight: 1,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 2,
  },
  aktualniRazpisiView: {
    flexDirection: "row",
    alignItems: "center",
    color: "white",
    backgroundColor: "#006a8e",
    padding: 5,
    paddingTop: 10,
  },
  aktualniRazpisiTitle: {
    fontSize: 13,
    fontWeight: "bold",
    flexBasis: "80%",
  },
  aktualniRazpisiText: {
    flexBasis: "20%",
    textAlign: "right",
  },
  podkategorijaNaziv: {
    backgroundColor: "#ededed",
    padding: 5,
    paddingTop: 10,
    fontWeight: "bold",
  },
  podkategorijaView: {
    flexDirection: "row",
    alignItems: "center",
    padding: 5,
    paddingTop: 10,
    borderBottom: "1px solid silver",
  },
  podkategorijaViewLast: {
    flexDirection: "row",
    alignItems: "center",
    padding: 5,
    paddingTop: 10,
  },
  podkategorijaNazivText: {
    flexBasis: "40%",
    paddingRight: 10,
  },
  podkategorijaOpisText: {
    flexBasis: "45%",
    textAlign: "justify",
  },
  podkategorijaDatumView: {
    flexBasis: "15%",
    textAlign: "right",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  razpisiDatumNovo: {
    border: "1px solid green",
    width: 25,
    color: "white",
    backgroundColor: "green",
    marginLeft: 53,
    marginBottom: 2,
    paddingTop: 5,
    paddingLeft: 2,
    paddingRight: 1,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 2,
  },
});

export default function CurrentTenderPDF({
  aktualniRazpisi,
  izpostavljeniAktualniRazpis,
  aktualniRazpisiVerzija,
  role,
}) {
  //deep copy aktualnih razpisov
  const poljeAktualniRazpisi = JSON.parse(JSON.stringify(aktualniRazpisi));

  //Odstranimo tiste podkategorije kjer ni razpisov.
  for (let i = 0; i < poljeAktualniRazpisi.length; i++) {
    for (let j = 0; j < poljeAktualniRazpisi[i].podkategorije.length; j++) {
      if (poljeAktualniRazpisi[i].podkategorije[j].razpisi.length === 0) {
        poljeAktualniRazpisi[i].podkategorije.splice(j, 1);
        j = j - 1;
      }
    }
  }

  //Odstranimo kategorije brez podkategorij
  const aktualniRazpisiFiltered = poljeAktualniRazpisi.filter((p, i) => {
    return p.podkategorije.length > 0;
  });

  const documentPDF = (
    <Document>
      <Page size="A4" style={styles.page}>



        {/* GLAVA */}
        <Text style={styles.aktualniRazpisiNaslov}>AKTUALNI RAZPISI</Text>
        <View style={styles.oddelekView}>
          <View style={styles.oddelekNaslovView}>
            <Text>Oddelek za raziskovalno in umetniško dejavnost</Text>
          </View>
          <View style={styles.oddelekVerzijaRazpisiView}>
            <Text>Aktualni razpisi</Text>
            <Text>
              {`${aktualniRazpisiVerzija.stevilka}/${new Date(
                aktualniRazpisiVerzija.datum
              ).getFullYear()}`}{" "}
              |
            </Text>
            <Text>
              {aktualniRazpisiVerzija && aktualniRazpisiVerzija.datum
                ? format(new Date(aktualniRazpisiVerzija.datum), "d. M. yyyy")
                : ""}
            </Text>
          </View>
        </View>
        <Text style={styles.opombaText}>
          Opomba: Pri rokih prijave je lahko ob datumu določena tudi ura.
          Preverite v razpisni dokumentaciji. Ure so navedene samo pri razpisih,
          objavljenih s strani ARIS.
        </Text>



        {/* IZPOSTAVLJENI RAZPISI */}
        {izpostavljeniAktualniRazpis.length > 0 && (
          <View style={styles.izpostavljeniRazpisiView}>
            <Text style={styles.izpostavljeniRazpisiTitle}>
              IZPOSTAVLJENI RAZPISI
            </Text>
            <Text style={styles.izpostavljeniRazpisiText}>Rok prijave</Text>
          </View>
        )}
        {izpostavljeniAktualniRazpis.map((razpisIzpostavljen, index, row) => {
          return (
            <View
              style={
                index + 1 === row.length
                  ? styles.razpisiIzpotavljeniDynamicViewLast
                  : styles.razpisiIzpotavljeniDynamicView
              }
              wrap={false}
            >
              <View style={styles.razpisiIzpostavljeniNaziv}>
                <Text>{razpisIzpostavljen.razpis_naziv}</Text>
              </View>
              <View style={styles.razpisiIzpostavljeniOpis}>
                {parseHtmlForPdf(razpisIzpostavljen.opis) || <Text>{razpisIzpostavljen.opis}</Text>}
              </View>
              <View style={styles.razpisiIzpostavljeniDatum}>
                {razpisIzpostavljen.novo === true && (
                  <Text style={styles.razpisiIzpostavljenDatumNovo}>Novo</Text>
                )}
                <Text>
                  {razpisIzpostavljen.razpis && razpisIzpostavljen.razpis !== "" ? (
                    razpisIzpostavljen.razpis
                  ) : (
                    <>
                      {razpisIzpostavljen.prijava_datum === "2100-01-01" &&
                        "Odprt razpis"}
                      {razpisIzpostavljen.prijava_datum !== null &&
                      razpisIzpostavljen.prijava_datum !== "2100-01-01"
                        ? format(
                            new Date(razpisIzpostavljen.prijava_datum),
                            "d. M. yyyy"
                          )
                        : ""}
                    </>
                  )}
                </Text>
                <Text>
                  {razpisIzpostavljen.prijava_ura !== null && (!razpisIzpostavljen.razpis || razpisIzpostavljen.razpis === "") &&
                    `do: ${razpisIzpostavljen.prijava_ura.slice(0, -3)}`}
                </Text>
              </View>
            </View>
          );
        })}



        {/* OSTALI RAZPISI */}
        {/* 1. nivo */}
        {aktualniRazpisiFiltered.map((razpis, index) => {
          return (
            <View>
              <View style={styles.aktualniRazpisiView} wrap={false}>
                <Text style={styles.aktualniRazpisiTitle}>
                  {razpis.kategorija}
                </Text>
                <Text style={styles.aktualniRazpisiText}>Rok prijave</Text>
              </View>

              {/* 2. nivo */}
              {razpis.podkategorije.map((podkategorija, index) => {
                return (
                  <View>
                    {podkategorija.podkategorijaID !== -1 && (
                      <View wrap={false}>
                        <Text style={styles.podkategorijaNaziv}>
                          {podkategorija.podkategorija}
                        </Text>
                      </View>
                    )}

                    {/* 3. nivo */}
                    {podkategorija.razpisi.length > 0 &&
                      podkategorija.razpisi.map((razpis, index, row) => {
                        return (
                          <View
                            style={
                              index + 1 === row.length
                                ? styles.podkategorijaViewLast
                                : styles.podkategorijaView
                            }
                            wrap={false}
                          >
                            <Text style={styles.podkategorijaNazivText}>
                              {razpis.url !== "" ? (
                                <Link src={razpis.url} wrap={false}>
                                  {razpis.naziv}
                                </Link>
                              ) : (
                                razpis.naziv
                              )}
                            </Text>
                            <View style={styles.podkategorijaOpisText}>
                              {razpis.opis !== "" ? (parseHtmlForPdf(razpis.opis) || <Text>{razpis.opis}</Text>) : <Text>Ni opisa</Text>}
                            </View>
                            <View style={styles.podkategorijaDatumView}>
                              {razpis.novo === true && (
                                <Text style={styles.razpisiDatumNovo}>
                                  Novo
                                </Text>
                              )}

                              <Text>
                                {razpis.razpis && razpis.razpis !== "" ? (
                                  razpis.razpis
                                ) : (
                                  <>
                                    {razpis.datum === "2100-01-01" &&
                                      "Odprt razpis"}
                                    {razpis.datum !== null &&
                                    razpis.datum !== "2100-01-01" &&
                                    razpis &&
                                    razpis.datum
                                      ? format(new Date(razpis.datum), "d. M. yyyy")
                                      : ""}
                                  </>
                                )}
                              </Text>
                              <Text>
                                {razpis.ura !== null && (!razpis.razpis || razpis.razpis === "") &&
                                  `do: ${razpis.ura.slice(0, -3)}`}
                              </Text>
                            </View>
                          </View>
                        );
                      })}
                  </View>
                );
              })}
            </View>
          );
        })}



        {/* PROMO */}
        <View style={{flexDirection: "row", alignItems: "center", marginTop: "20px", paddingTop: "20px", borderTop: "1px solid silver", gap: "20px"}}>
          <View style={{flexDirection: "column", flex: "1", alignItems: "center"}}>
            <Image style={{width: "50%"}} src={logo1}></Image>
          </View>
          <View style={{flexDirection: "column", flex: "1", alignItems: "center"}}>
            <Image style={{width: "70%"}} src={logo2}></Image>
          </View>
        </View>

        <View style={{flexDirection: "row", gap: "20px", marginTop: "10px"}}>
          <View style={{flexDirection: "column", flex: "1"}}>
            <Text style={{fontWeight: "bold"}}>Pivot-RP: Hiter dostop do relevantnih razpisov</Text>
            <Text>Poiščite razpise po meri vašega raziskovalnega področja, prejemajte prilagojena obvestila ter izkoristite napredna orodja za načrtovanje projektov.</Text>
            <Link style={{marginTop: "10px"}} src="https://pivot.proquest.com/login">Prijavite se v Pivot-RP</Link>
          </View>
          <View style={{flexDirection: "column", flex: "1"}}>
            <Text style={{fontWeight: "bold"}}>Crowdhelix: Globalna mreža raziskovalnega povezovanja</Text>
            <Text>Crowdhelix vam omogoča enostavno iskanje strokovnjakov in partnerjev, odkrivanje razpisov, prilagojenih vašim interesom, ter večjo prepoznavnost in možnosti mreženja v mednarodnem prostoru.</Text>
            <Link style={{marginTop: "10px"}} src="https://platform.crowdhelix.com/login">Prijavite se v Crowdhelix</Link>
          </View>
        </View>

        <View>
          <Text style={{marginTop: "20px", fontWeight: "bold"}}>Obe platformi sta brezplačno dostopni članom UM. Ustvarite svoj račun in odkrijte razpisne priložnosti, ki najbolje ustrezajo vašim raziskovalnim ciljem.</Text>
        </View>



        {/* "NOGA */}
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) => `${pageNumber}/${totalPages}`}
          fixed
        />
      </Page>
    </Document>
  );

  return (
    <div>
      <Row>
        <Col>
          {role.aktualniRazpisi === 2 && (
            <>
              <PDFDownloadLink
                document={documentPDF}
                fileName={`Aktualni_razpisi`}
                className="no-underline "
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <span className="ms-1 mb-5 mt-5">Nalaganje...</span>
                  ) : (
                    <Button variant="info" className="mb-2">
                      Izvozi PDF
                    </Button>
                  )
                }
              </PDFDownloadLink>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
}
